import { render, staticRenderFns } from "./RoundControlPointForm.vue?vue&type=template&id=52c49d90"
import script from "./RoundControlPointForm.vue?vue&type=script&lang=js"
export * from "./RoundControlPointForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports